export const ForgotPasswordPath = {
  forgotPassword: {
    to: '/forgot-password'
  },
  backToLogin: {
    to: 'sign-in'
  }
};
